import Crud from '../components/Equipment/Crud'

let routes = {
    path: '/equipment',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {            
            path: '/equipment',
            component: Crud
        }
    ]        
}

export default routes


// WEBPACK FOOTER //
// ./src/router/equipment.js